
import ListComponent from "../../../components/box_records/Index.vue";

export default {
  components: {
    ListComponent
  }
}
